var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import Component from '@arco-design/web-react/es/Modal/modal';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
import { confirm, error, info, success, warning } from './notifications';
function useModal(initState) {
    if (initState === void 0) { initState = false; }
    var _a = useState(initState), visible = _a[0], setVisible = _a[1];
    var show = function () { return setVisible(true); };
    var hide = function () { return setVisible(false); };
    return {
        visible: visible,
        show: show,
        hide: hide,
    };
}
var Modal = function (props) {
    var className = props.className, children = props.children;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-modal";
    return (React.createElement(Component, __assign({}, props, { className: cx(prefixCls, className) }), children));
};
Modal.confirm = confirm;
Modal.info = info;
Modal.success = success;
Modal.warning = warning;
Modal.error = error;
Modal.useModal = useModal;
var ModalComponent = Modal;
ModalComponent.displayName = 'Modal';
export default ModalComponent;
//# sourceMappingURL=index.js.map